import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axiosInstance from "../../services/FetchNodeServices";

const EditAbout = () => {
  const navigate = useNavigate();
  const [title, setTitle] = useState("About Us");
  const [paragraphs, setParagraphs] = useState([""]);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Fetch existing data on mount
  useEffect(() => {
    const fetchAbout = async () => {
      try {
        const res = await axiosInstance.get("/api/v1/about/get-about");
        if (res.status === 200) {
          setTitle(res.data.title || "About Us");
          setParagraphs(
            res.data.paragraphs?.length > 0 ? res.data.paragraphs : [""]
          );
        }
      } catch (error) {
        toast.error("Failed to load About Us data");
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchAbout();
  }, []);

  const handleAddParagraph = () => {
    setParagraphs((prev) => [...prev, ""]);
  };

  const handleRemoveParagraph = (index) => {
    if (paragraphs.length === 1) {
      toast.error("At least one paragraph is required");
      return;
    }
    setParagraphs((prev) => prev.filter((_, i) => i !== index));
  };

  const handleParagraphChange = (index, value) => {
    setParagraphs((prev) =>
      prev.map((p, i) => (i === index ? value : p))
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const cleanParagraphs = paragraphs.map((p) => p.trim()).filter(Boolean);
    if (cleanParagraphs.length === 0) {
      toast.error("Please add at least one paragraph");
      return;
    }

    setIsSubmitting(true);
    try {
      const res = await axiosInstance.post("/api/v1/about/create-or-update", {
        title: title.trim(),
        paragraphs: cleanParagraphs,
      });

      if (res.status === 200 || res.status === 201) {
        toast.success("About Us updated successfully!");
        setTimeout(() => navigate("/all-about"), 1500);
      }
    } catch (error) {
      toast.error("Error updating About Us");
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isLoading) return <p>Loading...</p>;

  return (
    <>
      <ToastContainer />

      <div className="bread">
        <div className="head">
          <h4>Edit About Us</h4>
        </div>
        <div className="links">
          <a onClick={() => navigate("/all-about")} className="add-new" style={{ cursor: "pointer" }}>
            Back <i className="fa-solid fa-arrow-left"></i>
          </a>
        </div>
      </div>

      <section className="p-4 bg-white border rounded mt-3">
        <form onSubmit={handleSubmit}>
          {/* Title */}
          <div className="mb-4">
            <label className="form-label fw-semibold">Page Title</label>
            <input
              type="text"
              className="form-control"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="About Us"
            />
          </div>

          {/* Paragraphs */}
          <div className="mb-3">
            <label className="form-label fw-semibold">
              Paragraphs
              <span className="text-muted fw-normal ms-2" style={{ fontSize: "13px" }}>
                (each textarea = one paragraph)
              </span>
            </label>

            {paragraphs.map((para, index) => (
              <div key={index} className="d-flex gap-2 mb-3 align-items-start">
                <div className="flex-grow-1">
                  <label className="text-muted mb-1" style={{ fontSize: "12px" }}>
                    Paragraph {index + 1}
                  </label>
                  <textarea
                    className="form-control"
                    rows={4}
                    value={para}
                    onChange={(e) => handleParagraphChange(index, e.target.value)}
                    placeholder={`Write paragraph ${index + 1}...`}
                  />
                </div>
                <button
                  type="button"
                  className="bt delete mt-4"
                  onClick={() => handleRemoveParagraph(index)}
                  title="Remove paragraph"
                >
                  <i className="fa-solid fa-trash"></i>
                </button>
              </div>
            ))}

            <button
              type="button"
              className="bt edit mt-1"
              onClick={handleAddParagraph}
            >
              <i className="fa-solid fa-plus me-1"></i> Add Paragraph
            </button>
          </div>

          <hr />

          {/* Live Preview */}
          {paragraphs.some((p) => p.trim()) && (
            <div className="mb-4 p-4 bg-light border rounded">
              <p className="fw-semibold mb-3 text-muted">Preview:</p>
              <h5 className="fw-bold mb-3">{title}</h5>
              {paragraphs
                .filter((p) => p.trim())
                .map((para, i) => (
                  <p key={i} className="mb-3" style={{ lineHeight: "1.8", textAlign: "justify", color: "#333" }}>
                    {para}
                  </p>
                ))}
            </div>
          )}

          <button
            type="submit"
            className="bt edit"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Updating..." : <>Update About Us <i className="fa-solid fa-floppy-disk ms-1"></i></>}
          </button>
        </form>
      </section>
    </>
  );
};

export default EditAbout;